import "./CreateDevice.css";
import { useEffect, useState } from "react";
import { Card, CircularProgress, Grid, MenuItem, TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
 } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import axios from "axios";

// Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

function CreateDevice() {
  const rState = useSelector((s) => s.user.userData);
  const auth = localStorage.getItem("authToken");
  const role = localStorage.getItem("role");
  const user_id = localStorage.getItem("user_id");
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [values, setValues] = useState({
    camera_name: "",
    device_type: "",
    aws_group_id: "",
    aws_thing_name: "",
    aws_end_point: "",
    area_id: "",
    user_id: user_id,
    camera_name: "",
    current_status: "",
  });
  const [loading, setLoading] = useState(false);
  const [allAreas, setAllAreas] = useState([]);
  const [allAdmins, setAllAdmins] = useState([]);
  const [bulkDeviceDialogOpen, setBulkDeviceDialogOpen] = useState(false);
  const [uploadExcelDialogOpen, setUploadExcelDialogOpen] = useState(false);
  const [numDevicesInput, setNumDevicesInput] = useState('');


  useEffect(() => {
    fetchAllAreas();
    fetchAllAdmins();

  }, []);

  const fetchAllAreas = async () => {
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BASEURL}/admin/areas/all`,
        { user_id: user_id },
        {
          headers: { Authorization: `Bearer ${auth}` },
        }
      )
      .then((res) => {
        if (!res.data?.success)
          return enqueueSnackbar("Error Fetching Areas !!!", { variant: "error" });

        setAllAreas(res.data.areas);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        enqueueSnackbar("Error Fetching Areas !!!", { variant: "error" });
      });
  };

    const fetchAllAdmins = async () => {
      setLoading(true);
      await axios
        .get(
          `${process.env.REACT_APP_BASEURL}/admin/users/all-admins`,
          {
            headers: { Authorization: `Bearer ${auth}` },
          }
        )
        .then((res) => {
          if (!res.data?.success)
            return enqueueSnackbar("Error Fetching Admins !!!", { variant: "error" });

          setAllAdmins(res.data.users);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          enqueueSnackbar("Error Fetching Admins !!!", { variant: "error" });
        });
    };

    const handleChange = (e) => setValues({ ...values, [e.target.name]: e.target.value });

    const handleBulkDeviceCreate = async () => {
      const numDevices = parseInt(numDevicesInput);
    
    if (!numDevices) {
        enqueueSnackbar("Please specify the number of devices", { variant: "error" });
        return;
      }
    
      setLoading(true);
    
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASEURL}/admin/device/addmultiple`,
          {
            number_of_device: numDevices,
          },
          {
            headers: {
              Authorization: `Bearer ${auth}`,
            },
          }
        );
    
        if (response.data.success) {
          enqueueSnackbar("Bulk device creation successful", { variant: "success" });
        } else {
          enqueueSnackbar("Bulk device creation failed", { variant: "error" });
        }
      } catch (error) {
        console.error("Error creating bulk devices:", error);
        enqueueSnackbar("An error occurred while creating bulk devices", {
          variant: "error",
        });
      } finally {
        setLoading(false);
        setBulkDeviceDialogOpen(false);
      }
    };
    
    
    const handleUploadExcel = () => {
      const fileInput = document.getElementById("excel-upload");
    
      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        handleFileUpload(file);
      } else {
        enqueueSnackbar("Please select a file to upload", { variant: "warning" });
      }
    };
    

    const handleFileUpload = async (file) => {
      try {
        const formData = new FormData();
        formData.append("file", file);
    
        const response = await axios.post(
          `${process.env.REACT_APP_BASEURL}/admin/device/importdevices`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${auth}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
  
        if (response.data.success) {
          enqueueSnackbar("File uploaded successfully", { variant: "success" });
          navigate("/devices");
        } else {
          enqueueSnackbar("File upload failed", { variant: "error" });
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        enqueueSnackbar("An error occurred while uploading the file", {
          variant: "error",
        });
      }
    };
    
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!values.device_name) {
      return enqueueSnackbar("Please provide a Device Name", { variant: "error" });
    }
    setLoading(true);

    const body = { ...values };

    await axios
      .post(`${process.env.REACT_APP_BASEURL}/admin/device/add`, body, {
        headers: { Authorization: `Bearer ${auth}` },
      })
      .then((res) => {
        if (res.data.success) {
          enqueueSnackbar("Device Added Successfully", { variant: "success" });
          navigate("/devices");
        } else {
          enqueueSnackbar(res.data.message, { variant: "error" });
        }
        return setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        return setLoading(false);
      });
  };
  
  return (
    <DashboardLayout>
    <DashboardNavbar hidebreadcrumbTitle />
    <MDBox pt={3} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            display="flex"
            justifyContent="space-between"
          >
            <MDTypography variant="h6" color="white">
              Create Device
            </MDTypography>
            <div>
              <MDButton
                variant="outlined"
                color="white"
                onClick={() => setBulkDeviceDialogOpen(true)}
                style={{marginRight: "8px"}}
              >
                Create Bulk Device
              </MDButton>
              <MDButton
                variant="outlined"
                color="white"
                onClick={() => setUploadExcelDialogOpen(true)}
              >
                Upload Excel
              </MDButton>
            </div>
          </MDBox>
            <MDBox p={3} component="form" role="form">
                <MDBox p={1}>
                  <MDInput
                    type="text"
                    label="Device Name"
                    value={values.device_name}
                    name="device_name"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                  />
                </MDBox>

                <MDBox p={1}>
                  <MDInput
                    type="text"
                    label="Camera Name"
                    value={values.camera_name}
                    name="camera_name"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                  />
                </MDBox>

              
                <MDBox p={1}>
                  <TextField
                    select
                    label="Select Admin"
                    fullWidth
                    className="creatSubAdmin_select"
                    margin="dense"
                    value={values.user_id}
                    onChange={(e) => setValues({ ...values, user_id: e.target.value })}
                  >
                    {allAdmins?.map((a) => (
                      <MenuItem key={a?.user_id} value={a?.user_id}>
                        {a?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </MDBox>
                

                <Grid container direction="row" justifyContent="flex-end" p={2} pb={0.5}>
                  <MDButton
                    variant="gradient"
                    color="info"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <CircularProgress size={20} sx={{ color: "inherit" }} />
                    ) : (
                      "Add Device"
                    )}
                  </MDButton>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
{/* Bulk Device Dialog */}
<Dialog open={bulkDeviceDialogOpen} onClose={() => setBulkDeviceDialogOpen(false)}>
  <DialogTitle>Bulk Device Creation</DialogTitle>
  <DialogContent>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          type="number"
          label="Number of Devices"
          fullWidth
          margin="dense"
          value={numDevicesInput}
          onChange={(e) => setNumDevicesInput(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          select
          label="Select Admin"
          fullWidth
          className="creatSubAdmin_select"
          margin="dense"
        >
          {allAdmins?.map((a) => (
            <MenuItem key={a?.user_id} value={a?.user_id}>
              {a?.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between">
          <Grid item>
            <MDButton onClick={() => setBulkDeviceDialogOpen(false)} color="secondary">
              Close
            </MDButton>
          </Grid>
          <Grid item>
            <MDButton onClick={() => handleBulkDeviceCreate()} color="info">
              Create
            </MDButton>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>

{/* Upload Excel Dialog */}
<Dialog open={uploadExcelDialogOpen} onClose={() => setUploadExcelDialogOpen(false)}>
  <DialogTitle>Upload Excel File</DialogTitle>
  <DialogContent>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <input
          type="file"
          accept=".xlsx, .xls, .csv"
          id="excel-upload"
          style={{ display: "none" }}
        />
        <label htmlFor="excel-upload">
          <MDButton
            component="span"
            color="info"
            startIcon={<CloudUploadIcon />}
          >
            Upload Excel File
          </MDButton>
        </label>
      </Grid>
      <Grid item xs={12}>
        <p>Download the template:</p>
        <a
          href="https://iot-smart-lightpost.s3.ap-south-1.amazonaws.com/ticket_documents/sample.xls"
          target="_blank"
          download
          rel="noopener noreferrer"
        >
          Template
        </a>
      </Grid>
    </Grid>
  </DialogContent>
  <DialogActions>
    <Grid container justifyContent="space-between">
      <Grid item>
        <MDButton onClick={() => setUploadExcelDialogOpen(false)} color="secondary">
          Close
        </MDButton>
      </Grid>
      <Grid item>
        <MDButton onClick={handleUploadExcel} color="info">
          Upload
        </MDButton>
      </Grid>
    </Grid>
  </DialogActions>
</Dialog>
    </DashboardLayout>
  );
}

export default CreateDevice;
